import React from 'react';
import { Row, Col, Form, Input, Select, InputNumber } from 'antd';

/**
 * 核心技能基本信息表单属性
 */
interface DriverCoreSkillsFormProps {
  // 当前组件不需要特殊属性，表单项通过Form上下文管理
}

/**
 * 核心技能基本信息表单组件
 */
const DriverCoreSkillsForm: React.FC<DriverCoreSkillsFormProps> = () => {
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Form.Item name="vehicleMaintSkill" label="车辆维修保养技能">
          <Input />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item name="mandarinAbil" label="普通话能力">
          <Select
            options={[
              { value: '标准', label: '标准' },
              { value: '一般', label: '一般' },
              { value: '不会', label: '不会' },
            ]}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item name="cargoTransQual" label="货物运输资质">
          <Input />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item name="xxyyDrivingBehavior" label="驾驶行为">
          <Select
            options={[
              { value: '优秀', label: '优秀' },
              { value: '良好', label: '良好' },
              { value: '合格', label: '合格' },
              { value: '差', label: '差' },
            ]}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item name="xxyyDrivingFocus" label="驾驶专注性">
          <Select
            options={[
              { value: '优秀', label: '优秀' },
              { value: '良好', label: '良好' },
              { value: '合格', label: '合格' },
              { value: '差', label: '差' },
            ]}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item name="xxyySmokingHabit" label="抽烟习惯">
          <Select
            options={[
              { value: '频繁', label: '频繁' },
              { value: '偶尔', label: '偶尔' },
              { value: '无', label: '无' },
            ]}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item name="ins3yClaimCnt" label="参保前3年出险次数">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default DriverCoreSkillsForm;
